export default "__VITE_ASSET__nSVUq9m2__"